import config from '@/config.js'
import router from '@/router.js'
import _ from 'lodash'
import axios from 'axios'
import http from '@/libs/http'
const redirectLogin = _.debounce(() => {
  if (!/^\/login(\/.+)?$/.test(location.pathname)) {
    router.replace('/login')
  }
}, 200)

export function login ({ commit }, auth) {
  commit('login', auth)
  localStorage.setItem(config.localTokenName, JSON.stringify(auth))
  commit('UpdateNewAdd', false)
  commit('SelectArea', undefined)
  router.replace('/')
}

export function logout ({ commit, dispatch }) {
  commit('logout')
  redirectLogin()
}

const debounceLoadAreas = _.debounce((commit) => {
  axios.get('https://store.zhaopeiyun.com/api/common/areas').then(resp => {
    commit('loadAreas', resp.data.data)
  })
}, 50, { trailing: false, leading: true })

const debounceLoadShops = _.debounce((commit, resolve) => {
  http.get('crm/erp/QueryShops').then(resp => {
    commit('loadShops', resp)
    resolve(resp)
  })
}, 50, { trailing: false, leading: true })

const debounceLoadStAreas = _.debounce((commit, resolve) => {
  http.get('crm/statistic/listareas').then((resp) => {
    commit('loadStAreas', resp || [])
    resolve(resp || [])
  })
}, 100, { trailing: false, leading: true })

const debounceLoadSubSellers = _.debounce((commit, resolve) => {
  http.get('crm/order/subsellerdicts').then((resp) => {
    commit('loadSubSellers', resp || [])
    resolve(resp || [])
  })
}, 50, { trailing: false, leading: true })

export function loadAreas ({ commit }) {
  debounceLoadAreas(commit)
}

export function loadShops ({ commit }) {
  return new Promise((resolve, reject) => {
    debounceLoadShops(commit, resolve)
  })
}

export function loadPermissions ({ commit }) {
  return axios.get('/permission.json').then(resp => {
    commit('loadPlainPermissions', _.cloneDeep(resp.data))
    resp.data.forEach(item => {
      if (item.code.indexOf('m.') === 0) {
        item.type = 1
      } else {
        item.type = 0
      }
      const nameArr = item.name.split('.')
      if (nameArr.length > 1) {
        item.group = nameArr[0]
        nameArr.splice(0, 1)
        item.name = nameArr.join('.')
        item.sortIdx = 0
      } else {
        item.group = item.name
        item.sortIdx = 1
      }
    })
    resp.data.sort((a, b) => b.type - a.type).sort((a, b) => b.sortIdx - a.sortIdx)
    const grpPermissions = []
    var grps = _.groupBy(resp.data, o => o.group)
    for (const key in grps) {
      grpPermissions.push({
        groupName: key,
        options: [...grps[key]]
      })
    }
    commit('loadPermissions', grpPermissions)
    return resp
  })
}

export function loadUiPrivilege ({ commit }) {
  return http.get('crm/privilege/infoget?type=2').then((resp) => {
    commit('loadUiPrivilege', resp)
    commit('setUiPrivilegeLoaded')
    return resp
  })
}

export function loadOrderBrands ({ commit }) {
  return http.get('crm/order/brands').then((resp) => {
    commit('loadOrderBrands', resp)
    return resp
  })
}

export function UpdateNewAdd ({ commit }, val) {
  commit(
    'UpdateNewAdd',
    val
  )
}

export function SelectArea ({ commit }, val) {
  commit('SelectArea', val)
}

export function loadStAreas ({ commit }) {
  return new Promise((resolve, reject) => {
    debounceLoadStAreas(commit, resolve)
  })
}

export function loadSubSellers ({ commit, dispatch }) {
  return new Promise((resolve, reject) => {
    debounceLoadSubSellers(commit, resolve)
  })
}
